import { AuxiliumComponent } from "../auxilium-component";

export class Callout extends AuxiliumComponent {
	static observedAttributes = ["heading", "variation", "hide-icon"];

	constructor() {
		super();

		this.variation ??= this.getAttribute("variation") ?? "info";
		this.heading ??= this.getAttribute("heading") ?? "";
		this.hideIcon = this.hasAttribute("hide-icon");
	}

	parsedCallback() {
		if (this.innerHTML?.trim() === "") { this.classList.add("callout--header-only"); }
		else {
			this.appendChild(document.createElementWithContents("div", this.childNodes, { className: "callout-body" }));
		}

		if (this.heading) {
			this.prepend(document.createElementWithContents("div", this.heading, { className: "callout__header" }));
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "heading") {
			const existing = this.querySelector(".callout__header");

			if (existing) {
				existing.innerHTML = newValue;
			} else {
				this.prepend(document.createElementWithContents("div", newValue, { className: "callout__header" }));
			}
		}
	}
}